import { Component } from '@angular/core';
import { ConfirmDialog, ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { ConfirmpopupService } from '../../services/confirmpopup.service';
@Component({
  selector: 'app-confirmpopup',
  imports: [ConfirmDialogModule,ConfirmDialog,ButtonModule],
  templateUrl: './confirmpopup.component.html',
  styleUrl: './confirmpopup.component.scss',
  providers: [ConfirmationService, MessageService]
})
export class ConfirmpopupComponent {
  public conformpopup:any;
  constructor(private _confirmationService: ConfirmationService, private _messageService: MessageService,private  _confirmpopup:ConfirmpopupService) {}

ngOnInit(){
  this._confirmpopup.getConfirmPopup().subscribe((data)=>{
   this.conformpopup=data;
  if(this.conformpopup.message){
    this.confirm2()
  }
  })
  
}

  confirm2() {
    this._confirmationService.confirm({
       
        message: this.conformpopup.message,
        header: this.conformpopup.header,
      
        rejectLabel: 'Cancel',
        rejectButtonProps: {
            label: this.conformpopup.cancelBtnName,
            severity: 'secondary',
            outlined: true,
        },
        acceptButtonProps: {
            label:this.conformpopup.acceptBtnname,
            severity: 'primary',
        },

        accept: () => {
            //this.messageService.add({ severity: 'info', summary: 'Confirmed', detail: 'Record deleted' });
        },
        reject: () => {
           // this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected' });
        },
    });
}
}
